import WBCONST from '../shared/constants/wb.const';

const { DEFAULT_THEME_COLOR } = WBCONST;

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

function normalizeHex(hex) {
  if (!hex) return DEFAULT_THEME_COLOR;
  let value = hex.trim().replace('#', '');

  if (value.length === 3) {
    value = value
      .split('')
      .map((char) => char + char)
      .join('');
  }

  if (!/^[0-9a-fA-F]{6}$/.test(value)) {
    return DEFAULT_THEME_COLOR;
  }

  return `#${value.toLowerCase()}`;
}

function hexToRgb(hex) {
  const normalized = normalizeHex(hex).replace('#', '');
  return {
    r: parseInt(normalized.slice(0, 2), 16),
    g: parseInt(normalized.slice(2, 4), 16),
    b: parseInt(normalized.slice(4, 6), 16),
  };
}

function rgbToHex(r, g, b) {
  const toHex = (channel) => clamp(Math.round(channel), 0, 255).toString(16).padStart(2, '0');

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

function mix(hex1, hex2, weight = 0.5) {
  const a = hexToRgb(hex1);
  const b = hexToRgb(hex2);

  return rgbToHex(
    a.r + (b.r - a.r) * weight,
    a.g + (b.g - a.g) * weight,
    a.b + (b.b - a.b) * weight
  );
}

function buildBrandShades(themeColor) {
  const base = normalizeHex(themeColor);

  const shades = {
    50: mix(base, '#ffffff', 0.92),
    100: mix(base, '#ffffff', 0.84),
    150: mix(base, '#ffffff', 0.76),
    200: mix(base, '#ffffff', 0.68),
    300: mix(base, '#ffffff', 0.52),
    400: mix(base, '#ffffff', 0.34),
    500: mix(base, '#ffffff', 0.18),
    600: base,
    700: mix(base, '#000000', 0.12),
    800: mix(base, '#000000', 0.24),
    900: mix(base, '#000000', 0.38),
  };

  return {
    base,
    ...shades,

    veryLight: shades[100],
    veryLightAlt: shades[150],
    light: shades[200],
    soft: shades[300],
    medium: shades[500],
    main: shades[600],
    dark: shades[800],
    darker: shades[900],

    contrastText: '#ffffff',
  };
}

export default buildBrandShades;
